import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-assessment-slider-left',
    templateUrl: './assessment-slider-left.component.html',
    styleUrls: ['./assessment-slider-left.component.scss'],
    standalone: false
})
export class AssessmentSliderLeftComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
